import React from 'react';
import { createRoot } from 'react-dom/client';
import { matchPath } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import _get from 'lodash/get';
import Root from './components/RootLandingPageMobile';
import configureStore from './store/landingPageStore';
import getWebpackPublicPath from './utils/commonUtils';
import entryPointSetup from './refresh/utils/entryPointUtils';
import Header from './components/mobile/header/Header';
import Footer from './components/mobile/footer/Footer';
import MobileShellRoutes from './config/mobileshellRoutes';
import { isMsiteRefresh } from './refresh/utils/cookie';
import 'regenerator-runtime/runtime';
import "./web-vitals-integration";
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => import('./initializeCopilot'), { timeout: 5000 });
} else {
  setTimeout(() => import('./initializeCopilot'), 5000);
}

const preloadedState = window.__PRELOADED_STATE__;
__webpack_public_path__ = getWebpackPublicPath();

const { store, persistor } = configureStore(preloadedState);
const { pathname = '' } = location;
const matchedShellUrlConfig = MobileShellRoutes.filter(routeConfig =>
  matchPath(pathname, routeConfig)
);
if (matchedShellUrlConfig && matchedShellUrlConfig.length) {
  const {
    headerConfig = {},
    footerConfig: { isFooter = true, ...restFooterConfig } = {}
  } = matchedShellUrlConfig[0];
  const { showHeader = true, showSisHeader = true } = headerConfig;
  const state = store.getState();
  const isSIS = _get(state, 'metaData.sis', false);
  const headerFlag = isSIS ? showSisHeader : showHeader;
  if (headerFlag && !isMsiteRefresh()) {
    const container = document.getElementById('header-markup');
    const root = createRoot(container);
    root.render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Header {...headerConfig} />
        </PersistGate>
      </Provider>
    );
  }
  if (isFooter && !isMsiteRefresh()) {
    const container = document.getElementById('footer-markup');
    const root = createRoot(container);
    root.render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Header {...headerConfig} />
        </PersistGate>
      </Provider>
    );
  }
}

if (window.pageType !== 'OFFLINEPAGE') {
  const container = document.getElementById('app');
  const root = createRoot(container);
  root.render(<Root store={store} persistor={persistor}/>);
}
entryPointSetup();
